import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const BarChart = ({ data, tooltipLabel }) => {
  const options = {
    credits: {
      enabled: false,
    },
    colors: ['#4b8c6f'],
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: data.map(({ name }) => name),
      lineWidth: 0,
      labels: {
        align: 'center',
        reserveSpace: true,
        format: '<div style="text-align: center;"><b>{text}</b></div>',
        formatter: (o) => {
          return `<div style="text-align: center;"><b>${o.value
            .split(' ')
            .join('<br />')}</b></div>`;
        },
        useHTML: true,
      },
    },
    yAxis: {
      tickLength: 1,
      gridLineWidth: 0,
      title: {
        text: '',
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 4,
        states: {
          hover: {
            color: '#4b8c6f80',
          },
        },
      },
    },
    tooltip: {
      backgroundColor: '#fff',
      borderRadius: 4,
      borderColor: '#ddd',
      borderWidth: 1,
      shadow: false,
      shape: 'rect',
      distance: 24,
      pointFormat: `<b>{point.y}</b><br/>${tooltipLabel}`,
      headerFormat: '',
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        data,
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default BarChart;
